export function advantages() {
  const names = document.querySelectorAll('.advantages__name');
  const mediaQuery = window.matchMedia('(min-width: 1024px)');

  if (!names.length) return;

  names.forEach((name) => {
    name.addEventListener('click', () => {
      if (mediaQuery.matches) return;

      const content = name.closest('.advantages__content');
      const text = content ? content.querySelector('.advantages__text') : null;

      if (!text) return;

      const isActive = name.classList.contains('is-active');

      if (isActive) {
        name.classList.remove('is-active');
        text.style.maxHeight = '0';
      } else {
        name.classList.add('is-active');
        text.style.maxHeight = text.scrollHeight + 'px';
      }
    });
  });

  window.addEventListener('resize', () => {
    if (mediaQuery.matches) {
      names.forEach((name) => {
        name.classList.remove('is-active');

        const content = name.closest('.advantages__content');
        const text = content ? content.querySelector('.advantages__text') : null;

        if (text) {
          text.style.maxHeight = '';
        }
      });
    }
  });
}
